import styled, { css } from "styled-components";

const commonStyles = css`
  display: contents;
  .containerEntregaLocal {
    width: 100rem;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    .titulo{
      margin-bottom: 0;
    }

    .textoEntregaLocal{
      text-align: left;
      padding: 1rem 0 4rem;
      width: 90%;
      color: ${(props) => props.theme.colors.tertiary};
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 30%;
        height: 2px;
        border-radius: 100%;
        background-color: ${(props) => props.theme.colors.elements};
      }
    }

    .dropdown {
      display: contents;
    }
    .cepContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2rem;
      position: relative;
      padding: 4rem 0;
      > .containerInput {
        margin-right: 10px;
      }
      &::after {
        content: "";
        position: absolute;
        width: 35rem;
        height: 2px;
        border-radius: 50px;
        background-color: ${(props) => props.theme.colors.elements};
        bottom: 0;
      }
    }
    .togglesContainer {
      display: flex;
      padding: 3rem 0 3rem 0;
      flex-direction: column;
      align-items: start;
      width: 90%;
      .togglesInnerContainer {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .containerToggleConfigurar {
          .nome {
            color: ${(props) => props.theme.colors.tertiary};
            width: 15rem;
          }
        }
        .taxaContainer{
          padding-top: 1rem;
        }
      }
    }
    .inputContainer {
      color: ${(props) => props.theme.colors.tertiary};
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      gap: 1rem;
      position: relative;
      padding: 0rem 10rem;
    }
  }
`;

export const ContainerEntregaLocal = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "configuracoes"
      ? css`
          .containerEntregaLocal {
            width: 100%;
            .textoEntregaLocal{
              padding: 3rem 0;
              width: 100%;
            }
            .dropdown {
              display: block;
              width: 100%;
              .cepContainer {
                color: ${(props) => props.theme.colors.tertiary};
                text-align: left;
                .containerInput {
                  width: 100%;
                  margin: 0;
                }
                .containerInputDias{
                  width: 100%;
                  margin: 0;
                }
                &::after {
                  display: none;
                }
              }
              .togglesContainer {
                padding: 0;
                display: block;
                align-items: center;
                width: 100%;
                gap: 4rem;
                .togglesInnerContainer {
                  display: contents;
                  .containerToggleConfigurar {
                    .nome {
                      width: auto;
                      margin-right: 2rem;
                    }
                  }
                }
              }
            }
          }
        `
      : null}
`;
